import { useEffect, useRef } from 'react';

export const useMountedEffect = (effect: () => void | (() => void), deps: Array<any>) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      const cleanupFn = effect() || (() => {});
      return cleanupFn;
    } else {
      isMounted.current = true;
      return () => {};
    }
  }, deps);
};
